import { render, staticRenderFns } from "./Togglelist.vue?vue&type=template&id=7967c8a4&scoped=true"
import script from "./Togglelist.vue?vue&type=script&lang=js"
export * from "./Togglelist.vue?vue&type=script&lang=js"
import style0 from "./Togglelist.vue?vue&type=style&index=0&id=7967c8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7967c8a4",
  null
  
)

export default component.exports